/**
 * Detects vape products that require a CA "Disposal Notice".
 *
 * Cartridges, 510s, pods and all-in-one vaporizers roll up under the
 * `CARTRIDGE` category. Standalone batteries / devices are filed under the
 * `MERCH` catch-all, so we fall back to matching vape keywords in the name.
 */
const VAPE_KEYWORDS =
  /\b(vape|vaporizer|battery|batteries|510|pod|cartridge|cart|all-?in-?one|disposable)\b/i;

export function isVapeProduct(product: {
  category?: string | null;
  name?: string | null;
}): boolean {
  const category = product.category?.toUpperCase();
  if (category === 'CARTRIDGE') return true;
  if (category === 'MERCH') return VAPE_KEYWORDS.test(product.name ?? '');
  return false;
}

export function DisposalNotice() {
  return (
    <div className="mb-6 flex flex-col items-start gap-2 border-t border-gray-200 pt-6">
      <h2 className="font-helvetica-neue text-xl leading-6 font-medium text-black">
        Disposal Notice
      </h2>
      <p className="font-helvetica-neue text-base leading-6 font-light tracking-[0.02em] text-black">
        A spent cannabis cartridge shall be properly disposed of as hazardous
        waste at a household hazardous waste collection facility or other
        approved facility.
      </p>
      <p className="font-helvetica-neue text-base leading-6 font-light tracking-[0.02em] text-black">
        An empty integrated cannabis vaporizer shall be properly disposed of as
        hazardous waste at a household hazardous waste collection facility or
        other approved facility.
      </p>
    </div>
  );
}
